module.exports = __webpack_public_path__ + "static/6a345f42802d9b98ba7861b7e0f2581e742bbe6628e1669c39cfad6cb9f37b06-01ee0edc67615620348ba820710bc050.jpeg";